import { render } from "./OrderList.vue?vue&type=template&id=ee213260&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=ts"
export * from "./OrderList.vue?vue&type=script&lang=ts"

import "./OrderList.vue?vue&type=style&index=0&id=ee213260&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-ee213260"

export default script